import React from "react";
import { useMailchimpHealthPolled } from "../../hooks/useIntegrationStatus";

const buildTitle = ({
  checking,
  ok,
  neverSynced,
  httpStatus,
  latencyMs,
  error,
}: {
  checking: boolean;
  ok: boolean | null;
  neverSynced: boolean;
  httpStatus: number | null;
  latencyMs: number | null;
  error: string | null;
}) => {
  const parts: string[] = [];
  if (checking) parts.push("Mailchimp check bezig…");
  else if (error) parts.push("Mailchimp fout");
  else if (neverSynced) parts.push("Mailchimp: nog nooit gesynct");
  else if (ok === true) parts.push("Mailchimp OK");
  else if (ok === false) parts.push("Mailchimp fout");
  else parts.push("Mailchimp status onbekend");
  if (httpStatus != null) parts.push(`HTTP ${httpStatus}`);
  if (latencyMs != null) parts.push(`${latencyMs}ms`);
  return parts.join(" • ");
};

export default function MailchimpStatusDot({ showLabel = true }: { showLabel?: boolean } = {}) {
  const snapshot = useMailchimpHealthPolled(true);
  const ok = (snapshot?.data as any)?.ok ?? null;
  const neverSynced = Boolean((snapshot?.data as any)?.neverSynced);
  const loading = Boolean(snapshot?.loading);
  const error = (snapshot?.error as any) ?? null;
  const meta = (snapshot?.meta as any) ?? { httpStatus: null, latencyMs: null };

  const checking = loading || (ok == null && !neverSynced && !error);
  const title = buildTitle({
    checking,
    ok,
    neverSynced,
    httpStatus: meta.httpStatus,
    latencyMs: meta.latencyMs,
    error,
  });

  const dotClass = checking
    ? "bg-amber-500 shadow-[0_0_0_4px_rgba(245,158,11,0.18)]"
    : ok === true || neverSynced
      ? "bg-emerald-500 shadow-[0_0_0_4px_rgba(16,185,129,0.18)]"
      : "bg-rose-500 shadow-[0_0_0_4px_rgba(244,63,94,0.18)]";

  return (
    <div className="flex items-center gap-2" title={title} aria-label={title}>
      <span className={`h-3 w-3 rounded-full ${dotClass}`} />
      {showLabel && (
        <span className="inline-flex items-center gap-1 text-sm font-semibold text-gray-600 dark:text-gray-300">
          Mailchimp
        </span>
      )}
    </div>
  );
}
